import React, { useEffect } from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import {
  GetPropertyVideoInfo,
  GetUnitVideoInfo,
} from "../../../../../../../../Services";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";
import { useTranslate } from "../../../../../../../../Hooks";
import {
  CustomInput,
  CustomSwitch,
  CustomTextArea,
} from "../../../../../../../../Components";

// styles
import useStyles from "./styles";

function VideoPublishDetailsComponent({
  activeVideo,
  videoPublishData,
  setVideoPublishData,
}) {
  const styles = useStyles();
  const { setAlertBoxContent } = useVerticalNav();
  const { translate } = useTranslate("NewPropertiesView");

  const isUnit = !!activeVideo?.unitId;

  const getVideoInfo = async () => {
    try {
      const res = isUnit
        ? await GetUnitVideoInfo(activeVideo)
        : await GetPropertyVideoInfo(activeVideo);
      if (res) {
        setVideoPublishData((prev) => ({ ...prev, ...res }));
      } else
        setVideoPublishData({
          propertyId: activeVideo?.propertyId,
          categoryId: activeVideo?.categoryId,
          fileId: activeVideo?.fileId,
          unitId: activeVideo?.unitId,
          categoryName: activeVideo?.categoryName,
          videoTitle: activeVideo?.categoryName,
          videoDescription: activeVideo?.categoryName,
        });
    } catch {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("something-went-wrong-Please-try-again"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
  };

  const updateVideoPublishData = (field, value) => {
    setVideoPublishData((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (activeVideo) {
      setVideoPublishData((prev) => ({
        ...prev,
        propertyId: activeVideo?.propertyId,
        unitId: activeVideo?.unitId,
        categoryId: activeVideo?.categoryId,
        fileId: activeVideo?.fileId,
        categoryName: activeVideo?.categoryName,
      }));
      getVideoInfo();
    }
  }, [activeVideo]);

  return (
    <Box className={styles.containerFileds}>
      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Video-title")}
        </Typography>
        <CustomInput
          hasSearchIcon={false}
          style={{ maxWidth: "100%" }}
          placeholder={translate("Enter")}
          onChange={(e) => {
            updateVideoPublishData("videoTitle", e.target.value);
          }}
          value={videoPublishData.videoTitle}
        />
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Property-description")}
        </Typography>
        <CustomTextArea
          maxRows={5}
          minRows={5}
          placeholder={translate("Remark")}
          onInputChange={(value) => {
            updateVideoPublishData("videoDescription", value);
          }}
          value={videoPublishData.videoDescription}
        />
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Is-published")}
        </Typography>
        <CustomSwitch
          size={"md"}
          label={translate("Published-in-portal")}
          checked={videoPublishData.isPublished}
          onChange={(e) => {
            const isChecked = e.target.checked;
            updateVideoPublishData("isPublished", isChecked);
            setVideoPublishData((prev) => ({
              ...prev,
              isMarketing: false,
            }));
          }}
          isDisabled={false}
        />
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Is-marketing")}
        </Typography>
        <CustomSwitch
          size={"md"}
          label={translate("For-marketing-purposes")}
          checked={videoPublishData.isMarketing}
          onChange={(e) => {
            const isChecked = e.target.checked;
            updateVideoPublishData("isMarketing", isChecked);
          }}
          isDisabled={!videoPublishData.isPublished}
        />
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Need-owner-approval")}
        </Typography>
        <Box className={styles.containerSwitchButtons}>
          <CustomSwitch
            size={"md"}
            label={translate("approval-needed")}
            checked={videoPublishData.isNeedOwnerApproval}
            onChange={(e) => {
              const isChecked = e.target.checked;
              updateVideoPublishData("isNeedOwnerApproval", isChecked);
            }}
            isDisabled={false}
          />
          <CustomSwitch
            size={"md"}
            label={translate("Is-approved")}
            checked={videoPublishData.isApproved}
            onChange={(e) => {
              const isChecked = e.target.checked;
              updateVideoPublishData("isApproved", isChecked);
            }}
            isDisabled={false}
          />
        </Box>
      </Box>

      <Divider />

      <Box className={styles.containerFiledItem}>
        <Typography className={styles.titleItem}>
          {translate("Comments")}
        </Typography>
        <CustomTextArea
          maxRows={5}
          minRows={5}
          placeholder={translate("Remark")}
          onInputChange={(value) => {
            updateVideoPublishData("comments", value);
          }}
          value={videoPublishData.comments}
        />
      </Box>
    </Box>
  );
}

export default VideoPublishDetailsComponent;
